import { useCallback } from 'react';
import { FieldArray } from 'formik';
import { List } from 'components/ui';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import TemplateFieldItem from 'components/template_field/item';
import NewTemplateField from 'components/template_field/new';

const DragAndDropField = ({ name, processing, formik }) => {
  const moveCard = useCallback((dragIndex, hoverIndex, arrayHelpers) => {
    arrayHelpers.move(dragIndex, hoverIndex);
  }, []);

  return (
    <DndProvider backend={HTML5Backend}>
      <FieldArray
        name={name}
        validateOnChange={false}
        render={(arrayHelpers) => (
          <List>
            {formik.values.templateFields.map((obj, index) => (
              <TemplateFieldItem
                key={obj.id ?? obj.name}
                id={obj.id}
                index={index}
                moveCard={moveCard}
                obj={obj}
                processing={processing}
                arrayHelpers={arrayHelpers}
                setFieldValue={formik.setFieldValue}
                errors={formik.errors}
              />
            ))}
            <NewTemplateField
              disabled={processing}
              existedNames={formik.values.templateFields.map((field) => field.name)}
              onSubmit={(data) => {
                arrayHelpers.push({ name: data.fieldName });
              }}
            />
          </List>
        )}
      />
    </DndProvider>
  );
};

export default DragAndDropField;
